/* src/app/private/components/tickets/delete-ticket/delete-ticket.component.scss */
/*# sourceMappingURL=delete-ticket.component.css.map */
